/**
 * Return the calculated height of a DOMelement
 * @param {DOMelement} el - the element to sizeup
 * @return {Number} The height of an element
 */
var outerHeight = function outerHeight(el) {
  var height = el.offsetHeight;
  var style = getComputedStyle(el);
  return height + parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
};

export default outerHeight;